import { Global, css } from '@emotion/react';

import React from 'react';

import { cssUtilities } from '../../css-utilities';
import { getAllCssVarsString, getThemeStylesString } from '../../css-variables';
import { getColorValue, getTextSize } from '../../utilities';

const buildGlobalStylesheet = (rootElement = ':root', bodyElement = 'body') => {
  return `
    ${rootElement} {
      font-size: 100%;
    }
    ${bodyElement} {
      --lns-fontFamily-body: "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif;
      --lns-fontFamily-heading: "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif;
      --lns-fontFamily-code: "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace;

      font-family: var(--lns-fontFamily-body);
      color: var(--ds-text, ${getColorValue('body')});
      ${getTextSize('body-md')};
    }

    ${bodyElement} *,
    ${bodyElement} *:before,
    ${bodyElement} *:after {
      box-sizing: border-box;
    }

    ${getThemeStylesString(rootElement)}

    ${getAllCssVarsString(rootElement)}

    ${cssUtilities()}
  `;
};

const BaseStyles = () => <Global styles={css(buildGlobalStylesheet())} />;

export default BaseStyles;
export { BaseStyles, buildGlobalStylesheet };
